export const OPEN_CHATTY_EVENT = 'openChatty';
export const UPDATE_SERVICE_CODE = 'updateServiceCode';
